class FalconPageHero extends HTMLElement {
  connectedCallback() {
    if (this.lifecycleController) return;

    this.lifecycleController = new AbortController();
    this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.panels = Array.from(this.querySelectorAll('[data-page-hero-panel]'));
    this.tabs = Array.from(this.querySelectorAll('[data-page-hero-tab]'));

    this.querySelectorAll('[data-page-hero-accordion]').forEach((trigger) => {
      trigger.addEventListener('click', () => this.toggleAccordion(trigger), {
        signal: this.lifecycleController.signal,
      });
    });

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activateTab(tab), {
        signal: this.lifecycleController.signal,
      });
    });
  }

  toggleAccordion(trigger) {
    const item = trigger.closest('[data-page-hero-accordion-item]');
    const contentId = trigger.getAttribute('aria-controls');
    const content = Array.from(this.querySelectorAll('[data-page-hero-accordion-content]'))
      .find((element) => element.id === contentId);
    const isOpen = !item?.classList.contains('is-open');

    item?.classList.toggle('is-open', isOpen);
    trigger.setAttribute('aria-expanded', String(isOpen));
    content?.setAttribute('aria-hidden', String(!isOpen));
  }

  activateTab(activeTab) {
    if (activeTab.classList.contains('is-active')) return;

    const targetId = activeTab.dataset.target;
    this.tabs.forEach((tab) => {
      const isActive = tab === activeTab;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
    });
    this.panels.forEach((panel) => {
      const isActive = panel.id === targetId;
      panel.classList.toggle('is-active', isActive);
      panel.setAttribute('aria-hidden', String(!isActive));
    });

    activeTab.scrollIntoView({
      behavior: this.motionQuery.matches ? 'auto' : 'smooth',
      block: 'nearest',
      inline: 'center',
    });
  }

  disconnectedCallback() {
    this.lifecycleController?.abort();
    this.lifecycleController = null;
  }
}

if (!customElements.get('falcon-page-hero')) {
  customElements.define('falcon-page-hero', FalconPageHero);
}
